import { Observable, of as observableOf } from 'rxjs';

import { map, mergeMap } from 'rxjs/operators';
import { Injectable } from "@angular/core";
import cloneDeep from 'lodash-es/cloneDeep';
import * as moment from 'moment';
import { HotelService, ISelectedQuotation, ISelectedQuotationHotel } from "libraries/hotel/services/hotel.service";
import { HelperService } from "libraries/hotel/services/helper.service";
import { IAccommodation, IDetailsOffer, IMealplan } from "libraries/hotel/models/details";
import { HotelResourceService } from "libraries/service/resources/hotel/hotelResource.service";
import { IQuoteRequest, ISearchRequest, ISegment } from "libraries/service/resources/hotel/ISearchParameters";
import { IHotelQuoteResourceResponse } from "libraries/service/resources/hotel/hotel-quotation";
import { ICompleteQuote, IHotelQuoteResponse, ISearchOffersResponse } from "libraries/service/resources/hotel/ISearchResponse";
import { IChangeRoom } from "./IChangeRoom";
import { ICost } from "libraries/service/resources/hotel/IResourceHotel";
import { giata } from '../config';

// #TODO 30-04-2018_FG Faire les interfaces et ajouter des commentaires

@Injectable()
export class HotelsListService {

    constructor(
        private readonly hotelService: HotelService,
        private readonly hotelResourceService: HotelResourceService,
        private readonly helperService: HelperService
    ) { }

    public refreshAlternatives(currentQuotation: ISelectedQuotationHotel, request) {
        if (!currentQuotation.property.hasOwnProperty('alternative')
            && !Array.isArray(currentQuotation.property.alternative)) {
            return false;
        }

        return currentQuotation.offers
            .map((offer: ICompleteQuote) => offer.host)
            .filter((host: string) => host !== request.hosts);
    }

    public addSelectedHotelToSelectedQuotation(selectedQuotation, hotelInformations, details, propertyHost: string): void {
        const existingSelectedHotels = selectedQuotation ? selectedQuotation.hotels : {};
        const selectedHotel = {
            selected: hotelInformations.syscode,
            hotels: {
                ...existingSelectedHotels,
                [hotelInformations.syscode]: {
                    description: details.description,
                    property: {
                        ...hotelInformations,
                        credit: propertyHost !== giata ? null : hotelInformations.credit,
                    },
                    offers: details.offers,
                    selectedOffer: details.offers[0].xId // By default the first offer is selected
                }
            }
        };

        this.hotelService.setSelectedQuotation(selectedHotel);
    }

    public updateExistingSelectedHotelToSelectedQuotation(selectedQuotation, hotelInformations): void {
        this.hotelService.setSelectedQuotation({
            ...selectedQuotation,
            selected: hotelInformations.syscode
        });
    }

    public changeRoom(selectedQuotation, offerChange: IChangeRoom): void {
        const selectedOffer: IDetailsOffer = offerChange.offers
            .find((offer: IDetailsOffer) => offer.host === offerChange.host);

        const cost: ICost = Object.values(selectedOffer.detail)
            .filter((roomItem: IAccommodation | IMealplan) => roomItem.xType === 'accomodation')
            .reduce((currentCost: ICost, roomItem: IAccommodation): ICost => {
                return Object.entries(roomItem.unit.cost)
                    .reduce((roomCost: ICost, [currency, value]: [string, number]): ICost => {
                        return {
                            ...roomCost,
                            [currency]: value + (currentCost[currency] || 0)
                        };
                    }, currentCost);
            }, {});

        const detailsWithRetail: (IAccommodation | IMealplan)[] = Object.values(selectedOffer.detail)
            .filter((roomItem: IAccommodation | IMealplan) => roomItem.xType === 'accomodation' && roomItem.unit.retail)

        let retail: ICost = null;

        if(detailsWithRetail?.length){
            retail = Object.values(selectedOffer.detail)
                .filter((roomItem: IAccommodation | IMealplan) => roomItem.xType === 'accomodation')
                .reduce((currentRetail: ICost, roomItem: IAccommodation): ICost => {
                    if(roomItem.unit.retail){
                        return Object.entries(roomItem.unit.retail)
                            .reduce((roomRetail: ICost, [currency, value]: [string, number]): ICost => {
                                return {
                                    ...roomRetail,
                                    [currency]: value + (currentRetail[currency] || 0)
                                };
                            }, currentRetail);
                    }
                    return null;

                }, {});
        }



        selectedOffer.total.cost = cost;
        if(retail){
            selectedOffer.total.retail = retail;

        }

        const selectedHotel = selectedQuotation.hotels[selectedQuotation.selected];

        const quotationToSet: ISelectedQuotation = {
            ...selectedQuotation,
            hotels: {
                ...selectedQuotation.hotels,
                [selectedQuotation.selected]: {
                    ...selectedHotel,
                    offers: offerChange.offers,
                    selectedOffer: offerChange.offerXid,
                    property: {
                        ...selectedHotel.property,
                        mealplan: selectedOffer.mealplan,
                        total: {
                            cost,
                        }
                    }
                }
            }
        }
        if(retail){
            quotationToSet.hotels[selectedQuotation.selected].property.total.retail = retail;
        }

        this.hotelService.setSelectedQuotation(quotationToSet);
    }

    public setOtherRoomsToSelectedQuotation(selectedQuotation, currentQuotation, property, otherRooms: ISearchOffersResponse, request): void {
        this.hotelService.setSelectedQuotation({
            ...selectedQuotation,
            hotels: {
                ...selectedQuotation.hotels,
                [property]: {
                    ...currentQuotation,
                    transactionId: otherRooms.transactionId,
                    property: {
                        ...currentQuotation.property,
                        ...otherRooms.property[property],
                        trip: currentQuotation.property.trip,
                        host: request.hosts,
                        dateLastCancellationWithoutPenalty: request.dateLastCancellationWithoutPenalty
                    },
                    rooms: {
                        ...currentQuotation.rooms,
                        [request.hosts]: otherRooms.room
                    },
                    selectedOffer: request.offerXid
                }
            }
        });
    }

    public updateExistingOhterRooms(selectedQuotation, currentQuotation, request): void {
        this.hotelService.setSelectedQuotation({
            ...selectedQuotation,
            hotels: {
                ...selectedQuotation.hotels,
                [selectedQuotation.selected]: {
                    ...currentQuotation,
                    property: {
                        ...currentQuotation.property,
                        trip: currentQuotation.property.trip,
                        host: request.hosts,
                        dateLastCancellationWithoutPenalty: request.dateLastCancellationWithoutPenalty
                    },
                    rooms: {
                        ...currentQuotation.rooms,
                    },
                    selectedOffer: request.offerXid
                }
            }
        });
    }

    public prepareSelectedQuotation(request, quotation) {
        if (quotation) {
            return observableOf(quotation.details);
        } else {
            return this.hotelResourceService.getQuotes({ trips: request.trips, properties: request.properties }).pipe(
                map((properties) => properties.quote[request.properties][request.hosts]));
        }
    }

    public setResponseToDetails(response: [IHotelQuoteResponse]): any {
    // public setResponseToDetails(response: [IHotelQuoteResponse, IGetPropertyResponse]): any {
        const otherRoomsResponse: any = response[0];
        // const descriptionResponse: any = response[1];
        const property: string = this.hotelService.getHotelId(otherRoomsResponse.property);

        return {
            offers: this.helperService.objectToArray(otherRoomsResponse.quote[property]),
            // description: descriptionResponse && descriptionResponse.property
        };
    }

    /**
     * Help to prepare segment before Quotation request
     * Add property needed about segment in this function
     */
    public formatSegment(selected: ICompleteQuote, requestFromCache: ISearchRequest) {
        let specialRooms = {};

        const detailsOfSelectedHostDetailsArray: Array<IAccommodation | IMealplan> = this.helperService.objectToArray(selected.detail);

        detailsOfSelectedHostDetailsArray
            .filter((detail: IAccommodation | IMealplan) => detail.xType === "accomodation")
            .forEach((detail: IAccommodation) => {
                specialRooms = {
                    ...specialRooms,
                    [detail.rooming]: {
                        rooming: detail.rooming,
                        xId: detail.xId,
                        syscode: detail.syscode,
                        farebasis: detail.farebasis
                    }
                };
            });

        const cleanedSegment: ISegment[] = requestFromCache.segment
            .map((segment: ISegment) => {
                let requestSegment: any = {
                    xType: 'Accomodation',
                    begin: moment(segment.begin).format('YYYY-MM-DD'),
                    end: moment(segment.end).format('YYYY-MM-DD'),
                    duration: segment.duration,
                    rooming: updateSegment(segment.rooming, specialRooms),
                };

                if (selected.mealplan) {
                    requestSegment = {
                        ...requestSegment,
                        mealplan: selected.mealplan.syscode
                    };
                }

                return requestSegment;
            });

        return cleanedSegment;
    }

    public getQuotation(selectedQuote: ISelectedQuotation, request: IQuoteRequest): Observable<IHotelQuoteResourceResponse> {
        const requestFromCache: ISearchRequest = cloneDeep(this.hotelService.getRequestFromCache());
        const selectedProperty: ISelectedQuotationHotel | ISelectedQuotation = selectedQuote.hotels ? selectedQuote.hotels[selectedQuote.selected] : selectedQuote;


        return observableOf(selectedProperty).pipe(
            mergeMap((selectedQuotation: ISelectedQuotationHotel): Observable<ICompleteQuote> => {
                const selectedOffer: ICompleteQuote = selectedQuotation
                    && selectedQuotation.offers
                    && selectedQuotation.offers.find(
                        (offer: ICompleteQuote) => offer.property === request.properties
                            && offer.host === request.hosts);

                if (!selectedOffer) {
                    return this.hotelResourceService.getQuotes({ trips: request.trips, properties: request.properties }).pipe(
                        map((properties: IHotelQuoteResponse): ICompleteQuote => properties.quote[request.properties][request.hosts]));
                }

                return observableOf(selectedOffer);
            }),
            map((selectedQuotation: ICompleteQuote) => {
                // Format body request
                const body: ISearchRequest = {
                    brand: requestFromCache.brand,
                    language: requestFromCache.language,
                    traveller: requestFromCache.traveller,
                    segment: this.formatSegment(selectedQuotation, requestFromCache),
                    transactionId: this.hotelService.getSelectedQuotationTransactionId() || selectedQuotation.transactionId,
                };

                // Keep request and add trips
                const formattedRequest: IQuoteRequest = {
                    ...request,
                    trips: request.trips
                    || (selectedProperty && (selectedProperty as ISelectedQuotationHotel).property.trip)
                };

                return { body, formattedRequest };
            }),
            mergeMap(({ body, formattedRequest }: { body: ISearchRequest, formattedRequest: IQuoteRequest }) => {
                return this.hotelResourceService.quote(formattedRequest, body);
            }));
    }
}


function updateSegment(rooming, specialRooms) {
    Object.keys(specialRooms).forEach((room) => {
        rooming[room] = {
            ...rooming[room],
            room: specialRooms[room].syscode,
            farebasis: specialRooms[room].farebasis
        };
    });

    return rooming;
}
